module.exports = __webpack_public_path__ + "img/BonusRateОfAttack.bb83ddf9.png";